import { useRender } from "../../context/renderContext";
import { useIssuesData } from "../../hooks/useIssues";
import IssueDonutCard from "../ui/IssueDonutCard";
const colors = ["#64b5f6", "#ff8a65", "#aed581", "#ffd54f", "#4db6ac", "#ba68c8"];
const PeopleDealingPersonalGrowth = () => {
  const { selectedOption, setSelectedOption, options } = useRender();
  const { issuesData } = useIssuesData();
  const handleChange = (event) => {
    setSelectedOption?.(event.target.value);
  };
  const prepareChartData = (personalGrowthData) => Object.entries(personalGrowthData??{}).map(([label, value], index) => ({
    id: index,
    value,
    color: colors[index % colors.length],
    label
  }));
  const chartData = issuesData ? prepareChartData(issuesData.personalGrowth) : [];

  return <IssueDonutCard
    title="People dealing with personal growth issues"
    count={issuesData?.personalGrowthCount || 0}
    caption="Total users dealing with personal growth issues"
    chartData={chartData}
    chartTitle="Personal Growth Issues"
    personalGrowth
    accent="magenta"
    dropdown={{ value: selectedOption, onChange: handleChange, options }}
  />;
};
var PeopleDealingPersonalGrowth_default = PeopleDealingPersonalGrowth;
export {
  PeopleDealingPersonalGrowth_default as default
};